module.exports = __webpack_public_path__ + "img/bot_sz1.3916c54e.png";